import styled from 'styled-components';
import { deepCoveDark, white, royal, darkBlue, whiteLilac } from '../../../../../app/js/components/loggedout/shared-styles/Colors';
import HeaderCurveBg from '~images/sem/purchase/header-curve-bg.png';
import OfferBannerImg from '~images/sem/purchase/offer-banner.png';
import OfferBannerDesktopImg from '~images/sem/purchase/offer-banner-desktop.png';
import {assetPath} from '../../../../../app/js/utils/web-helper';
import { fontQuicksand } from '../../../common/mixins/mixin';
import { device, breakpoints, getWidthRange } from '../../../../../app/js/utils/responsive_utilities';
export const Wrapper = styled.div`
  background: url(${assetPath(HeaderCurveBg)}) top center/cover no-repeat, ${deepCoveDark};
  width: 100vw;
  background-size: 100% 100%;
  @media ${device.Phone}{
    display : ${(props) => props.passwordScreen ? 'none' : 'block'};
  }
  @media (min-width: ${breakpoints.lg}px) {
    background-image: none;
    background-color: ${whiteLilac};
    flex-basis: 30.18%;
    padding-top: 5.9rem;
  }
  @media ${device.TabletLandscape}{
    flex-basis: 40%;
  }
`;
export const HeaderTitle = styled.h2`
  margin: 0;
  text-align: center;
  padding: 3.2rem 1rem 1.2rem;
  ${fontQuicksand(2, 2.4, 7)}
  color: ${white};
  @media (min-width: ${breakpoints.lg}px) {
    text-align: left;
    padding: 0 2% 0 10%;
    color: ${darkBlue};
    ${fontQuicksand(3.4, 4.2, 7)}
  }
  @media (min-width: ${breakpoints.xl}px) {
    padding: 0 3% 0 31.03%;
  }
`;
export const HeaderSubTitle = styled.p`
  padding: 0.5rem 0 1.6rem;
  margin: 0;
  text-align: center;
  color: ${white};
  ${fontQuicksand(1.2, 1.2, 7)}
  @media (min-width: ${breakpoints.lg}px) {
    text-align: left;
    padding: 0.5rem 2% 0 10%;
    color: ${darkBlue};
    ${fontQuicksand(1.6, 2, 7)}
  }
  @media (min-width: ${breakpoints.xl}px) {
    padding: 1.5rem 3% 0 31.03%;
  }
`;
export const OfferBanner = styled.div`
  background: url(${assetPath(OfferBannerImg)}) center/cover no-repeat;
  width: 31.4rem;
  height: 4.8rem;
  margin: 0 auto;
  padding: 0.5rem 0;
  box-sizing: border-box;
  @media (min-width: ${breakpoints.lg}px) {
    margin: 2rem 0 0 auto;
    background: url(${assetPath(OfferBannerDesktopImg)}) center/cover no-repeat;
    width: 90%;
  }
  @media (min-width: ${breakpoints.xl}px) {
    width: 73.56%;
  }
`;
export const OfferTime = styled.div`
  color: ${white};
  ${fontQuicksand(1.6, 2, 7)};
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    color: ${darkBlue};
  }
`;
export const OfferText = styled.div`
  color: ${white};
  ${fontQuicksand(1.2, 1.6, 7)};
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    color: ${darkBlue};
  }
`;
export const ExtraInfoWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding: 2.4rem 0.5rem 3.8rem;
  @media (min-width: ${breakpoints.lg}px) {
    padding: 5rem 2% 0 10%;
    flex-direction: column;
  }
  @media (min-width: ${breakpoints.xl}px) {
    padding: 5rem 3% 0 31.03%;
  }
`;
export const ExtraInfo = styled.div`
  display: flex;
  flex-basis: 9.5rem;
  p{
    margin: 0;
  }
  &:nth-child(1) {
    flex-direction: column;
    flex-basis: 6.6rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex-grow: 1;
    flex-flow: row wrap;
    justify-content: flex-start;
    width: 100%;
    align-items: center;
    flex-basis: 6rem;
    margin-bottom: 1rem;
    &:nth-child(1) {
      flex-direction: row;
      flex-basis: auto;
      img{
        width:7rem;
        position: relative;
        left: -0.9rem;
        max-width: none;
      }
    }
  }
`;
export const InfoIcon = styled.div`
  flex-basis: 40%;
  height: ${props => props.firstInfoIcon === "text" ? 'auto' : '3.8rem'};
  width: 3.8rem;
  ${props => props.firstInfoIcon === "img" ? 'display: none;' : ''}
  p{
    color: #FD825D;
    ${props => props.firstInfoIcon === 'text' ? fontQuicksand(1.6, 1.8, 7) : fontQuicksand(1.6, 2.4, 7)}
    margin: 0;
  }
  & > img {
    width: 100%;
    height: 100%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    ${props => props.firstInfoIcon === "img" ? 'display: inline;' : (props.firstInfoIcon === "text" ? 'display: none;' : '')}
    height: 5rem;
    width: 5rem;
    flex-basis: auto;
    margin-right: 5.05%;
  }
`;
export const Info = styled.div`
  flex-basis: 60%;
  ${fontQuicksand(1.1, 1.3, 5)}
  color: ${white};
  margin: ${props => props.bottomText ? '0' : 'auto 0 0.2rem 0.4rem'};
  @media (min-width: ${breakpoints.lg}px) {
    color: ${darkBlue};
    ${fontQuicksand(1.6, 2, 5)}
    flex-grow: 1;
    margin: 0;
  }
`;

export const LogoImage = styled.div`
  width: 50%;
  display: none;
  img {
    width: 100%;
    height: 100%;
    margin-top: 0.4rem;
  }

  @media (min-width: ${breakpoints.lg}px) {
    display: block;
    margin: 0px 0 3rem 10%;
  }

  @media (min-width: ${breakpoints.xl}px) {
    margin: 0px 0 3rem 31.03%;
  }

`